import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const WelcomeSection = () => {
  return (
    <section data-testid="welcome-section" className="py-20 md:py-32 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Welcome Block */}
          <div className="section-card p-8 lg:p-10">
            <span className="text-[#D4AF37] font-accent text-xs uppercase tracking-[0.2em]">
              Welcome
            </span>
            <div className="gold-divider-left my-4" />
            <h2 className="text-2xl md:text-3xl font-medium text-white mb-4">
              Discover LuxuryStyle
            </h2>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Welcome to LuxuryStyle, where elegance meets durability. Our curated collection 
              of premium jewellery pieces are crafted with 18K gold plated stainless steel, 
              designed to withstand the test of time while maintaining their stunning appearance.
            </p>
            <p className="text-white/60 text-sm leading-relaxed mb-8">
              Every piece in our collection is waterproof and tarnish-free, perfect for those 
              who live life without limits. Experience luxury that you can wear anywhere, anytime.
            </p>
            <Link
              to="/about"
              data-testid="welcome-read-more"
              className="inline-flex items-center space-x-2 text-[#D4AF37] hover:text-[#F2D06B] transition-colors group"
            >
              <span className="font-accent text-xs uppercase tracking-[0.2em]">Read More</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Latest Collections Block - Center */}
          <div className="relative group">
            <div className="relative overflow-hidden">
              <img
                src="https://cdn.shopify.com/s/files/1/0971/0187/3536/files/IMG_5322.jpg?v=1768826327"
                alt="Latest jewellery collection featuring elegant gold bracelets"
                className="w-full h-[400px] lg:h-[500px] object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              {/* Decorative Frame Effect */}
              <div className="absolute inset-4 border border-[#D4AF37]/30 pointer-events-none" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/90 to-transparent">
              <span className="text-[#D4AF37] font-accent text-xs uppercase tracking-[0.2em]">
                Featured
              </span>
              <h3 className="text-2xl md:text-3xl font-medium text-white mt-2 mb-4">
                Latest Collections
              </h3>
              <p className="text-white/60 text-sm mb-4">
                Explore our newest arrivals, crafted for those who appreciate timeless beauty.
              </p>
              <Link
                to="/collections"
                data-testid="collections-cta"
                className="btn-luxury-outline inline-block text-xs"
              >
                View Collection
              </Link>
            </div>
          </div>

          {/* Our History Block */}
          <div className="section-card p-8 lg:p-10">
            <span className="text-[#D4AF37] font-accent text-xs uppercase tracking-[0.2em]">
              Our Story
            </span>
            <div className="gold-divider-left my-4" />
            <h2 className="text-2xl md:text-3xl font-medium text-white mb-4">
              Our History
            </h2>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Born from a passion for accessible luxury, LuxuryStyle was founded with a simple 
              mission: to create jewellery that combines high-end aesthetics with everyday 
              practicality.
            </p>
            <p className="text-white/60 text-sm leading-relaxed mb-8">
              Our commitment to quality means every piece undergoes rigorous testing to ensure 
              it meets our standards for durability, beauty, and comfort. We believe luxury 
              should be experienced, not just admired.
            </p>
            <Link
              to="/about"
              data-testid="history-read-more"
              className="inline-flex items-center space-x-2 text-[#D4AF37] hover:text-[#F2D06B] transition-colors group"
            >
              <span className="font-accent text-xs uppercase tracking-[0.2em]">Read More</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>

      {/* Decorative Gold Line */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-20">
        <div className="flex items-center justify-center">
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
          <div className="mx-4">
            <div className="w-2 h-2 bg-[#D4AF37] transform rotate-45" />
          </div>
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
